export var updateCursorPosition = function (textarea, linkIconRef, setCursorPosition) {
    if (typeof window === 'undefined' || !textarea.current)
        return;
    var cursorPos = textarea.current.selectionStart;
    var div = document.createElement('div');
    div.style.whiteSpace = 'pre-wrap';
    div.style.wordWrap = 'break-word';
    div.style.visibility = 'hidden';
    div.style.position = 'absolute';
    div.style.width = textarea.current.offsetWidth + 'px';
    div.style.font = window.getComputedStyle(textarea.current).font;
    div.style.padding = window.getComputedStyle(textarea.current).padding;
    div.style.lineHeight = window.getComputedStyle(textarea.current).lineHeight;
    div.textContent = textarea.current.value.substring(0, cursorPos);
    var span = document.createElement('span');
    span.textContent = '.';
    div.appendChild(span);
    var textareaWrapper = document.querySelector('.textarea-wrapper');
    if (textareaWrapper) {
        textareaWrapper.appendChild(div);
    }
    else {
        document.body.appendChild(div);
    }
    var rect = span.getBoundingClientRect();
    var textareaRect = textarea.current.getBoundingClientRect();
    var top = rect.top - textareaRect.top + textarea.current.scrollTop - 15;
    var left = rect.left - textareaRect.left;
    if (textareaWrapper) {
        textareaWrapper.removeChild(div);
    }
    else {
        document.body.removeChild(div);
    }
    setCursorPosition({ top: top, left: left });
    if (linkIconRef.current) {
        linkIconRef.current.style.top = "".concat(top + 10, "px");
        linkIconRef.current.style.left = "".concat(left + 10, "px");
    }
};
//# sourceMappingURL=updaleCursorPosition.js.mapexport var updateCursorPosition = function (textarea, linkIconRef, setCursorPosition) {
    if (typeof window === 'undefined' || !textarea.current)
        return;
    var cursorPos = textarea.current.selectionStart;
    var div = document.createElement('div');
    div.style.whiteSpace = 'pre-wrap';
    div.style.wordWrap = 'break-word';
    div.style.visibility = 'hidden';
    div.style.position = 'absolute';
    div.style.width = textarea.current.offsetWidth + 'px';
    div.style.font = window.getComputedStyle(textarea.current).font;
    div.style.padding = window.getComputedStyle(textarea.current).padding;
    div.style.lineHeight = window.getComputedStyle(textarea.current).lineHeight;
    div.textContent = textarea.current.value.substring(0, cursorPos);
    var span = document.createElement('span');
    span.textContent = '.';
    div.appendChild(span);
    var textareaWrapper = document.querySelector('.textarea-wrapper');
    if (textareaWrapper) {
        textareaWrapper.appendChild(div);
    }
    else {
        document.body.appendChild(div);
    }
    var rect = span.getBoundingClientRect();
    var textareaRect = textarea.current.getBoundingClientRect();
    var top = rect.top - textareaRect.top + textarea.current.scrollTop - 15;
    var left = rect.left - textareaRect.left;
    if (textareaWrapper) {
        textareaWrapper.removeChild(div);
    }
    else {
        document.body.removeChild(div);
    }
    setCursorPosition({ top: top, left: left });
    if (linkIconRef.current) {
        linkIconRef.current.style.top = "".concat(top + 10, "px");
        linkIconRef.current.style.left = "".concat(left + 10, "px");
    }
};
//# sourceMappingURL=updaleCursorPosition.js.map